import React, { useEffect, useState } from "react";
import "./GuestPlayModal.scss";

interface GuestPlayModalProps {
  show: boolean;
  handleClose: () => void;
  handleDemoPlay: () => Promise<void> | void;
  handleSignIn: () => void;
}

const GuestPlayModal: React.FC<GuestPlayModalProps> = ({
  show,
  handleClose,
  handleDemoPlay,
  handleSignIn,
}) => {
  const [isLaunching, setIsLaunching] = useState(false);

  useEffect(() => {
    if (show) {
      document.body.classList.add("guest-modal-open");
    } else {
      document.body.classList.remove("guest-modal-open");
      setIsLaunching(false);
    }

    return () => {
      document.body.classList.remove("guest-modal-open");
    };
  }, [show]);

  const onLaunchClick = async () => {
    if (isLaunching) return;
    setIsLaunching(true);

    try {
      await handleDemoPlay();
    } catch (error) {
      console.error("Failed to launch game:", error);
      setIsLaunching(false);
    }
  };

  if (!show) return null;

  return (
    <div className="guest-play-modal">
      <div className="modal-bg">
        <div className="guest-play-content">
          <h3 className="heading-guest-modal">Continue in Demo?</h3>

          <div className="modal-actions">
            <button
              className="guest-modal-buutton guest-modal-buutton-primary normal-text"
              onClick={onLaunchClick}
              disabled={isLaunching}
            >
              {isLaunching ? "Launching..." : "Launch Game, I confirm I'm 18+"}
            </button>
            <button
              className="guest-modal-buutton guest-modal-buutton-secondary normal-text"
              onClick={handleSignIn}
            >
              Sign In
            </button>
          </div>

          <button className="modal-close" onClick={handleClose}>
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestPlayModal;
